module.exports = __webpack_public_path__ + "img/dy_p0_img_3.af36027d.png";